import firebase from "firebase/compat/app";

export async function verifyActionCode(actionCode: string): Promise<firebase.auth.ActionCodeInfo> {
  return await firebase.auth().checkActionCode(actionCode);
}

export async function verifyPasswordResetCode(actionCode: string): Promise<string> {
  return await firebase.auth().verifyPasswordResetCode(actionCode);
}
